import Vue from 'vue';
import Vuetify from 'vuetify/lib';
// import "@mdi/font/css/materialdesignicons.css"
import "material-design-icons-iconfont/dist/material-design-icons.css"

Vue.use(Vuetify);

export default new Vuetify({
	theme: {
		options: {
			customProperties: true
		},
		themes: {
			light: {
				background: "#f3f8fe",
				primary: "#5555a5",
				secondary: "#03a9f4",
				accent: "#2196f3",
				error: "#f44336",
				warning: "#ff5722",
				info: "#00bcd4",
				success: "#4caf50",
				green: '#66be67'
			},
			dark: {
				background: "#f3f8fe",
				primary: "#5555a5",
				secondary: "#03a9f4",
				accent: "#2196f3",
				error: "#f44336",
				warning: "#ff5722",
				info: "#00bcd4",
				success: "#4caf50",
				green: '#66be67'
			}
		}
	},
	icons: {
		iconfont: "md"
	}
})
